<template>
    <div class="layout-container">
        <div class="layout__title">
            <span class="title">{{ title }}</span>
            <span v-if="required" class="require">*</span>
        </div>
        <slot></slot>
    </div>
</template>

<style lang="less" scoped>
.layout {
    &-container {
        padding: 9px 12px;
        background: #fff;
        .title,
        .require {
            font-size: 14px;
            font-weight: 400;
        }
        .title {
            color: #191A1E;
            line-height: 20px;
            margin-bottom: 5px;
        }
        .require {
            color: #F45642;
            line-height: 20px;
            margin-left: 2px;
        }
    }
    &__title {
        font-size: 14px;
    }
}
</style>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '默认文案'
        },
        required: {
            type: Boolean,
            default: false
        }
    }
}
</script>

